import { Field } from '../field';
import { SubmissionGlobalValue } from '../../formulas/types/ComputerDefinition';

export class ConsumptionNumberField extends Field {
  /**
   * Customise the initialise value function so the consumption numbers default to 0
   * if they don't already have a value
   * @param reportDate
   * @param globalValues
   */
  initialiseValue(reportDate: Date | string, globalValues: SubmissionGlobalValue[]) {
    super.initialiseValue(reportDate, globalValues);
    if (!this.state.content) {
      this.setExistingContent(0);
    }
  }
}
